/* eslint-disable jsx-a11y/anchor-has-content */
import {
  Route,
  BrowserRouter,
  withRouter,
} from 'react-router-dom';
import React, { PureComponent } from 'react';
import getLocale from 'browser-locale';

import HomePage from './HomePage';
import NewsPage from './NewsPage';

import './App.css';

let locale = getLocale();
locale = locale.replace(/-\S*/g, '');

class App extends PureComponent {
  render() {
    return (
      <BrowserRouter>
        <div className="app">
          <Route
            exact
            path="/:locale?"
            render={withRouter((props) => {
              locale = props.match.params.locale || locale;
              return (<HomePage
                {...props}
                locale={locale}
              />);
            })}
          />
          <Route
            path="/:locale?/news/:date"
            render={withRouter((props) => {
              locale = props.match.params.locale || locale;
              return (<NewsPage
                {...props}
                locale={locale}
              />);
            })}
          />
          <div className="block copy-right">
            <div className="container">
              © 2017 ALL RIGHTS RESERVED
              <ul>
                <li>
                  <a
                    className="fb"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/mrrichbakery/?hc_ref=ARTcKGw6hOWEdUSHByhgqG48GXm0J4SIqCjLPgjHdEMdnqGkusnKola0MxLTNiU_2ZY&fref=nf"
                  />
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="instgram"
                    href="https://www.instagram.com/mrrichbakery/?hl=zh-tw"
                  />
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="weibo"
                    href="http://weibo.com/mrrichbakery"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

// export default translate('view', { wait: true })(App);
export default App;



// WEBPACK FOOTER //
// ./src/App.js